import axios from "../../../../../axios";
import { useRef, useEffect, useState } from "react";
import "./filterBox.css";
import DatePicker from "react-datepicker";

import { toast } from "react-toastify";

let dummyArr = [{}];
const FilterBox = ({ setFilter, filter, setIsPopupOpen }) => {
  const safeParse = (key, defaultValue = []) => {
    try {
      const value = localStorage.getItem(key);
      if (!value) return defaultValue;
      return JSON.parse(value);
    } catch (e) {
      console.warn(`Invalid JSON in localStorage for key: ${key}`);
      return defaultValue;
    }
  };

  let generalRole_JSON = safeParse("general_role", []);
  let classTeacher_JSON = safeParse("role_as_class_teacher", []);
  let cordinator_JSON = safeParse("role_as_co_ordinator", []);

  const [subjectList, setSubjectList] = useState({
    subjectName: [],
  });
  const { subjectName } = subjectList;
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [Active, setActive] = useState(false);
  //User selected data
  const [selectedData, setSelectedData] = useState("");
  const [datepick, setDatePick] = useState(filter.date);

  useEffect(() => {
    const getsubjectList = async () => {
      dummyArr = [];
      try {
        function addUniqueObjectToArray(obj) {
          if (
            !dummyArr.some(
              (item) => JSON.stringify(item) === JSON.stringify(obj),
            )
          ) {
            dummyArr.push(obj);
          }
        }
        if (classTeacher_JSON.length > 0) {
          let res = await axios.get(
            `/api/v1/school/standardId/${classTeacher_JSON[0]?.standard_id?.id}/sectionId/${classTeacher_JSON[0]?.section_id?.id}/getSubjects`,
          );

          const subjectSource =
            res?.data?.data?.subjectConfigurations?.length > 0
              ? res.data.data.subjectConfigurations.map((item) => item.subject)
              : res.data.data.subjects;

          subjectSource.forEach((obj) => addUniqueObjectToArray(obj));
        }

        if (cordinator_JSON.length > 0) {
          let res = await axios.get(
            `/api/v1/school/standardId/${cordinator_JSON[0]?.standard_id?.id}/sectionId/${cordinator_JSON[0]?.section_id?.id}/getSubjects`,
          );

          const subjectSource =
            res?.data?.data?.subjectConfigurations?.length > 0
              ? res.data.data.subjectConfigurations.map((item) => item.subject)
              : res.data.data.subjects;

          subjectSource.forEach((obj) => addUniqueObjectToArray(obj));
        }
        if (generalRole_JSON.length > 0) {
          generalRole_JSON.forEach((obj) => {
            obj?.subjects_id?.forEach((para) => {
              addUniqueObjectToArray(para);
            });
          });
        }

        setSubjectList({
          subjectName: dummyArr,
        });
      } catch (error) {
        console.log(error);
      }
    };

    getsubjectList();
  }, []);

  useEffect(() => {
    localStorage.setItem("selectedCheckboxes", JSON.stringify(selectedOptions));
  }, [selectedOptions]);
  useEffect(() => {
    localStorage.setItem("selectedDay", JSON.stringify(selectedData));
  }, [selectedData]);
  useEffect(() => {
    localStorage.setItem("selectedDate", JSON.stringify(datepick));
  }, [datepick]);
  const handleSubjects = () => {
    setFilter((prev) => ({
      ...prev,
      subjectId: selectedOptions,
      date: datepick,
      time: selectedData,
    }));

    toast.success("Filters applied");
    setIsPopupOpen(false);
  };
  const handleclear = () => {
    setFilter((prev) => ({ ...prev, subjectId: [], date: "", time: "" }));
    //localStorage.clear();
    localStorage.removeItem("selectedDate");
    localStorage.removeItem("selectedCheckboxes");
    localStorage.removeItem("selectedDay");
    setIsPopupOpen(false);
    // window.location.reload();
  };
  useEffect(() => {
    selectedData && setActive(true);
  }, [selectedData]);
  const handleOptionChange = (event) => {
    const optionId = event.target.value;
    if (event.target.checked) {
      setSelectedOptions([...selectedOptions, optionId]);
    } else {
      setSelectedOptions(selectedOptions.filter((id) => id !== optionId));
    }
  };
  function handleSpanClick(event) {
    setSelectedData(event);
  }
  const PreReadbtns = document.querySelectorAll(".timeBtn_pre");
  PreReadbtns.forEach((btnElCM) => {
    btnElCM.addEventListener("click", () => {
      document.querySelector(".focusbtns1")?.classList.remove("focusbtns1");
      btnElCM.classList.add("focusbtns1");
    });
  });

  // calnder icon click filter
  const startDatePickerRef = useRef(null);

  const handleStartDateClick = () => {
    startDatePickerRef.current.setOpen(true);
  };

  function handledatePick(date) {
    setDatePick(date);
  }

  const renderAppliedFilters = () => {
    const chips = [];

    if (filter.searchvalue) {
      chips.push({
        label: `Search: ${filter.searchvalue}`,
        key: "search",
        onDelete: () => setFilter((prev) => ({ ...prev, searchvalue: "" })),
      });
    }

    if (filter.standard_id) {
      chips.push({
        label: `Class`,
        key: "class",
        onDelete: () =>
          setFilter((prev) => ({ ...prev, standard_id: "", section_id: "" })),
      });
    }

    if (filter.section_id) {
      chips.push({
        label: `Section`,
        key: "section",
        onDelete: () => setFilter((prev) => ({ ...prev, section_id: "" })),
      });
    }

    if (filter.subjectId?.length > 0) {
      chips.push({
        label: `Subjects (${filter.subjectId.length})`,
        key: "subjects",
        onDelete: () => setFilter((prev) => ({ ...prev, subjectId: [] })),
      });
    }

    if (filter.time) {
      chips.push({
        label: `Time: ${filter.time}`,
        key: "time",
        onDelete: () => setFilter((prev) => ({ ...prev, time: "" })),
      });
    }

    if (filter.date) {
      chips.push({
        label: `Date`,
        key: "date",
        onDelete: () => setFilter((prev) => ({ ...prev, date: "" })),
      });
    }

    return chips;
  };

  return (
    <>
      <div className="py-2 d-flex filter_container_PreRead ">
        <div className="filter_box">
          <img src="/images/filter_icon.svg" />
          <span>Filter</span>
        </div>

        <div className="otherCnt">
          <div className="col-5 filter_subj_box_pre">
            <h5 className="mb-2 filter_first_heading_pre">SUBJECT</h5>
            <div className=" px-0 d-flex align-item-center flex-column subject_subbox_pre  ">
              {/* <div className=" "> */}
              {subjectName.map((option) => (
                <div key={option.id} className="d-flex">
                  <input
                    type="checkbox"
                    id={option.id}
                    name={option.name}
                    value={option.id}
                    checked={selectedOptions.includes(option.id)}
                    onChange={handleOptionChange}
                  />
                  <label
                    htmlFor={option.id}
                    className={
                      selectedOptions.includes(option.id)
                        ? "ms-1 mt-2 checkedSubject subject_subBox_pre_span"
                        : "ms-1 mt-2 options_styler subject_subBox_pre_span"
                    }
                  >
                    {option.name}
                  </label>
                </div>
              ))}
              {/* </div> */}
            </div>
          </div>
          <div className="col-7 p-0 filter_time_box">
            <h5 className="mb-2 filter_first_heading_pre">TIME</h5>
            <div className="col-12 d-flex justify-content-between gap-2 filter_both_column ">
              <div className="col-6 d-flex gap-2 flex-column p-0 subject_subBox_pre">
                <button
                  value="today"
                  onClick={() => {
                    handleSpanClick("today");
                  }}
                  className={
                    selectedData === "today"
                      ? "timeBtn_pre focusbtns1"
                      : "timeBtn_pre"
                  }
                >
                  <span className="BTNText">Today</span>
                </button>

                <button
                  value="thisweek"
                  onClick={() => {
                    handleSpanClick("thisweek");
                  }}
                  className={
                    selectedData === "thisweek"
                      ? "timeBtn_pre focusbtns1"
                      : "timeBtn_pre"
                  }
                >
                  <span className="BTNText">This Week</span>
                </button>

                <button
                  value="thismonth"
                  onClick={() => {
                    handleSpanClick("thismonth");
                  }}
                  className={
                    selectedData === "thismonth"
                      ? "timeBtn_pre focusbtns1"
                      : "timeBtn_pre"
                  }
                >
                  <span className="BTNText">This Month</span>
                </button>
              </div>
              <div className="col-6 d-flex gap-2  flex-column p-0 subject_subBox_pre">
                <button
                  value="yesterday"
                  onClick={() => {
                    handleSpanClick("yesterday");
                  }}
                  className={
                    selectedData === "yesterday"
                      ? "timeBtn_pre focusbtns1"
                      : "timeBtn_pre"
                  }
                >
                  <span className="BTNText">Yesterday</span>
                </button>

                <button
                  value="lastweek"
                  onClick={() => {
                    handleSpanClick("lastweek");
                  }}
                  className={
                    selectedData === "lastweek"
                      ? "timeBtn_pre focusbtns1"
                      : "timeBtn_pre"
                  }
                >
                  <span className="BTNText">Last Week</span>
                </button>

                <button
                  value="lastmonth"
                  onClick={() => {
                    handleSpanClick("lastmonth");
                  }}
                  className={
                    selectedData === "lastmonth"
                      ? "timeBtn_pre focusbtns1"
                      : "timeBtn_pre"
                  }
                >
                  <span className="BTNText">Last Month</span>
                </button>
              </div>
            </div>
            {!Active && (
              <>
                <h5 className="mt-2 filter_first_heading_pre">PICK A DATE</h5>
                <div className="filter_date_picker_pre d-flex justify-content-between">
                  <div>
                    <DatePicker
                      ref={startDatePickerRef}
                      selected={datepick}
                      onChange={handledatePick}
                      dateFormat="dd/MM/yyyy"
                      className="SelectDate"
                      placeholderText="DD:MM:YYYY"
                      value={filter.date || datepick}
                    />
                  </div>
                  <img
                    src="/images/CalenderIconFilter.svg"
                    onClick={handleStartDateClick}
                    className="calenderImgFilter"
                  />
                </div>
              </>
            )}
            <div className="float-right">
              <button
                className="btn  m-2  filter_clear_btn_pre "
                onClick={(e) => {
                  handleclear();
                }}
              >
                Clear
              </button>
              <button
                className="btn m-2 filter_apply_btn_pre"
                onClick={(e) => {
                  handleSubjects();
                }}
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FilterBox;
